import { Pipe, PipeTransform } from '@angular/core';
import { ThirdPartyAddress } from '../interfaces/thirdParty';

@Pipe({
    name: 'filterThirdPartyAddresses',
    pure: false

})
export class filterThirdPartyAddressesPipe implements PipeTransform {
    transform(data: ThirdPartyAddress[], filter: string): ThirdPartyAddress[] {
        if (!data || !data.length) return [];
        if (!filter) return data;
        return data.filter(thirdPartyAddress => {
            const branchOfficeName = thirdPartyAddress && thirdPartyAddress.branchOfficeName ? thirdPartyAddress.branchOfficeName : null;
            if (branchOfficeName && branchOfficeName.toLowerCase().includes(filter.toLowerCase())) return true;
            const address = thirdPartyAddress && thirdPartyAddress.address && thirdPartyAddress.address.address ? thirdPartyAddress.address.address : null;
            if (address && address.toLowerCase().includes(filter.toLowerCase())) return true;
            return false;
        });
    }
}